module.exports = __webpack_public_path__ + "static/images/icon-loading.2t2c58-.svg";